<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="3.8259mm" height="5.0001mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 7321 9568"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_674076712">
     <path class="fil0 str0" d="M2502 3427c-142,702 -647,1571 -189,2186 210,282 1372,822 1747,983 -190,470 -1011,1101 -759,1601 138,275 503,412 809,207 111,-75 447,-528 556,-679 170,-238 353,-462 538,-698 148,-190 469,-493 281,-882 -118,-243 -449,-373 -712,-521 -222,-125 -592,-360 -800,-434 198,-989 1059,-2187 414,-2854 -744,-766 -1743,-116 -2772,302 -753,306 -716,137 -913,987 -61,261 -114,500 -172,766 -64,298 -144,529 62,738 200,202 538,143 670,-41 199,-278 306,-1333 477,-1426 76,-41 660,-217 763,-235z"/>
     <path class="fil0 str0" d="M3049 6448c-321,-131 -648,-295 -880,-523l-219 -261c-147,298 -118,906 -213,1273 -39,149 -567,656 -700,798 -249,264 -997,876 -1033,1213 -26,248 91,423 247,528 432,290 789,-185 972,-353l1139 -1098c124,-123 298,-243 397,-371 124,-163 266,-942 290,-1206z"/>
     <path class="fil0 str0" d="M5754 3230c-275,-236 -559,-495 -869,-706 159,694 48,629 -85,1215l562 428c175,130 393,354 710,189 163,-84 752,-920 906,-1131 120,-162 364,-383 341,-649 -23,-280 -279,-473 -581,-393 -277,74 -733,880 -984,1047z"/>
     <path class="fil0 str0" d="M4529 24c-1287,291 -841,2182 419,1907 464,-102 871,-586 729,-1185 -106,-445 -575,-850 -1148,-722z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Scene',
};
</script>

<style scoped>
.fil0 {fill:#666666}
.str0 {stroke:#666666;stroke-width:100}
</style>
